import PropTypes from 'prop-types';
import React from 'react';
import {useSiteSettings, withSiteSettings} from './withSiteSettings';

export const useTrackFont = () => {
  const siteSettings = useSiteSettings();
  return siteSettings.fonts.trackTitle;
};

export const withTrackFont: any = (Component) => {
  const ComponentWithTrackFont = ({siteSettings, children, ...props}) => {
    return (
      <Component trackFont={siteSettings.fonts.trackTitle} {...props}>
        {children}
      </Component>
    );
  };
  ComponentWithTrackFont.propTypes = {
    siteSettings: PropTypes.object,
    children: PropTypes.node,
  };
  return withSiteSettings(ComponentWithTrackFont);
};
